import React from 'react';
import { Modal, Button, Icon } from 'antd';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';

class ModalLoggedSkill extends React.Component {

  constructor() {
    super();
    this.state = {
      imagePreview: false,
      image: ""
    }
  }

  shouldImageViewerOpen = (fileName) => {
    console.log('filename', fileName);
    if (fileName &&
        (fileName.substr(fileName.length - 3) == 'jpg' ||
        fileName.substr(fileName.length - 3) == 'JPG' ||
        fileName.substr(fileName.length - 3) == 'png' ||
        fileName.substr(fileName.length - 3) == 'PNG' ||
        fileName.substr(fileName.length - 4) == 'jpeg' ||
        fileName.substr(fileName.length - 4) == 'JPEG')
      ) {
        return true
      } else {
        return false
      }
  }

  render() {

    const t = this.props.t
    const attachments = this.props.data.attachments && Object.entries(this.props.data.attachments)

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.isOpen}
          onCancel={this.props.cancel}
          width={680}
          footer={false}
        >
          <h3>{t('Name')}</h3>
          <p>{this.props.data.name}</p>
          <h3>{t('Subject')}</h3>
          <p>{t(this.props.data.subject)}</p>
          <h3>{t('Skill Category')}</h3>
          <p>{t(this.props.data.category)}</p>
          <h3>{t('Skill Cluster')}</h3>
          <p>{t(this.props.data.cluster)}</p>
          <h3>{t('Skill Level')}</h3>
          <p>{t(this.props.data.level)}</p>
          <h3>{t('Skill Descriptor')}</h3>
          <p>{t(this.props.data.skillCluster)}</p>
          {this.props.data.notes &&
            <div>
              <h3>{t('Notes')}</h3>
              <p>{this.props.data.notes}</p>
            </div>
          }
          {attachments &&
            <div>
            <h3>{t('File Attached')}</h3>
              <div>
                {attachments.map(file => (
                  <div style={{display: 'inline-flex', width: '100%'}}>
                    <Icon style={{fontSize: '18px'}} type="file-text" />
                    {this.shouldImageViewerOpen(file[1].name) ?
                      <p style={{marginBottom: 0}} onClick={() => this.setState({image: file[1].path, imagePreview: true})}>{file[1].name}</p>
                    :
                      <a target="_blank" href={file[1].path}><p style={{marginBottom: 0}}>{file[1].name}</p></a>
                    }
                  </div>
                ))}
              </div>
            </div>
          }
        </Modal>
        <Viewer
          visible={this.state.imagePreview}
          onClose={() => { this.setState({ imagePreview: false }); } }
          images={[{src: this.state.image, alt: ''}]}
          attribute={false}
          drag={false}
          zoomable={false}
          rotatable={false}
          scalable={false}
          changable={false}
          noNavbar={true}
          noToolbar={true}
          noFooter={true}
        />
      </div>
    )
  }
}

export default ModalLoggedSkill;



// WEBPACK FOOTER //
// ./src/components/ModalLoggedSkill/index.jsx